/**
 * The footprints this plan has used for one equipment type, one click each.
 *
 * The wall-thickness chips, in two dimensions — shown where a size is set:
 * arming the equipment tool, and editing one already placed. One size is not a
 * choice, so the row appears at two.
 */
import { useTranslation } from 'react-i18next'
import { Button } from '../ui/button'
import type { EquipmentSize } from './useEquipmentSizes'

interface EquipmentSizeChipsProps {
    /** Most recent first — see `useEquipmentSizes`. */
    recent: EquipmentSize[]
    /** The size in effect here: the armed one, or the selected element's. */
    active: EquipmentSize
    onPick: (size: EquipmentSize) => void
}

const label = (size: EquipmentSize): string => `${size.width}×${size.depth}`

export function EquipmentSizeChips(props: EquipmentSizeChipsProps) {
    const { t } = useTranslation('assets')
    if (props.recent.length < 2) return null

    return (
        <div className="flex flex-wrap items-center gap-1 pt-1" data-testid="plan-editor-equipment-size-recent">
            <span className="text-[11px] text-muted-foreground">{t('planEditor.thickness_recent')}</span>
            {props.recent.map((size) => {
                const active = size.width === props.active.width && size.depth === props.active.depth
                return (
                    <Button
                        key={label(size)}
                        variant={active ? 'default' : 'outline'}
                        size="sm"
                        className="h-6 px-2 text-xs"
                        aria-pressed={active}
                        data-testid={`plan-editor-equipment-size-${size.width}x${size.depth}`}
                        onClick={() => props.onPick(size)}
                    >
                        {label(size)}
                    </Button>
                )
            })}
        </div>
    )
}
